export const PATROL_CONDITION_SHEET_IDS = {
  start: "patrol-vehicle-condition-start",
  end: "patrol-vehicle-condition-end",
} as const;

export type PatrolConditionSheetId =
  (typeof PATROL_CONDITION_SHEET_IDS)[keyof typeof PATROL_CONDITION_SHEET_IDS];

function urlFilesOnly(files: unknown): string[] {
  return Array.isArray(files) ? files.filter((file): file is string => typeof file === "string") : [];
}

export function getPatrolConditionSheetId(mode: "start" | "end"): PatrolConditionSheetId {
  return mode === "start"
    ? PATROL_CONDITION_SHEET_IDS.start
    : PATROL_CONDITION_SHEET_IDS.end;
}

export function getPatrolConditionFormDraftKey(mode: "start" | "end", shiftId: number) {
  return `patrol-condition:${mode}:shift${shiftId}`;
}

export function serializePatrolConditionFormDraftValues(values: Record<string, unknown>) {
  return {
    company_vehicle_id: values.company_vehicle_id ?? 0,
    odometer_miles: values.odometer_miles ?? "",
    fuel_level: values.fuel_level ?? "",
    notes: values.notes ?? "",
    service_requests: Array.isArray(values.service_requests) ? values.service_requests : [],
    files: urlFilesOnly(values.files),
  };
}

export function deserializePatrolConditionFormDraftValues(values: Record<string, unknown>) {
  return {
    ...values,
    service_requests: Array.isArray(values.service_requests) ? values.service_requests : [],
    files: Array.isArray(values.files) ? values.files : [],
  };
}

export function patrolConditionHasPersistableContent(values: Record<string, unknown>) {
  const notes = typeof values.notes === "string" ? values.notes.trim() : "";
  const odometer = typeof values.odometer_miles === "string" ? values.odometer_miles.trim() : "";
  const files = Array.isArray(values.files) ? values.files : [];
  const serviceRequests = Array.isArray(values.service_requests) ? values.service_requests : [];
  const vehicleId = values.company_vehicle_id;
  return (
    notes.length > 0 ||
    odometer.length > 0 ||
    files.length > 0 ||
    serviceRequests.length > 0 ||
    (typeof vehicleId === "number" && vehicleId > 0) ||
    (typeof values.fuel_level === "string" && values.fuel_level.length > 0)
  );
}

export function isPatrolConditionSheetId(sheetId: string): sheetId is PatrolConditionSheetId {
  return Object.values(PATROL_CONDITION_SHEET_IDS).includes(sheetId as PatrolConditionSheetId);
}

export function patrolConditionModeFromSheetId(sheetId: string): "start" | "end" | null {
  if (sheetId === PATROL_CONDITION_SHEET_IDS.start) return "start";
  if (sheetId === PATROL_CONDITION_SHEET_IDS.end) return "end";
  return null;
}
